module.exports = __webpack_public_path__ + "static/img/leshen.f54c3dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/leshen.png
// module id = 0iMO
// module chunks = 0